import type { FC } from 'react';
import React, { useMemo } from 'react';

import { isTouchDevice } from '../../helpers/is-touch-device';

import type { TBannerLink, TEmptyCallback } from './models';

export const SubsectionLink: FC<TBannerLink> = ({
    BannerLink,
    DataLayer,
    DropDown,
    analytics,
    dropDownData,
    link = '#',
    onEnter,
    onLeave,
    styles,
    title,
}) => {
    const dropDownElement = useMemo(() => <DropDown dropDownData={dropDownData} />, [dropDownData]);
    let onEnterEvent: TEmptyCallback | undefined;
    let onLeaveEvent: TEmptyCallback | undefined;
    let className = styles.bottomRowBasic;

    if (dropDownData) {
        onEnterEvent = onEnter;
        onLeaveEvent = onLeave;
        className = styles.bottomRow;
    }

    /** Фикс для планшетов, выпадающие списки должны открываться
     * но переход по ссылке не должен происходит
     * TODO: в рамках задачи ALFABANKRU-34331 пересмотр UX виджета */
    const preventClick = dropDownData && isTouchDevice;

    return (
        <span
            className={className}
            onBlur={onLeaveEvent}
            onFocus={onEnterEvent}
            onMouseLeave={onLeaveEvent}
            onMouseOver={onEnterEvent}
        >
            <DataLayer data={analytics}>
                <BannerLink link={preventClick ? undefined : link} title={title}>
                    {title}
                </BannerLink>
            </DataLayer>
            {dropDownElement}
        </span>
    );
};
